import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import site from '../../data/site.json';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner tra-container">
        <div className="footer__brand">
          <img src={process.env.PUBLIC_URL + site.logo} alt={site.name} />
          <p>{site.subheadline || 'The creator-first agency for gaming brands.'}</p>
          <div className="footer__socials">
            {site.socials?.instagram && (
              <a href={site.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            )}
            {site.socials?.twitter && (
              <a href={site.socials.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
            )}
            {site.socials?.youtube && (
              <a href={site.socials.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
            )}
          </div>
        </div>

        <div className="footer__cols">
          <div className="footer__col">
            <h4>Agency</h4>
            <Link to="/talent-roster">Our Creators</Link>
            <a href="/#services">Services</a>
            <a href="/#work">Work</a>
            <a href="/#process">Process</a>
          </div>
          <div className="footer__col">
            <h4>Connect</h4>
            <a href="/#contact">Contact</a>
            <a href={`mailto:${site.email}`}>{site.email}</a>
          </div>
          <div className="footer__col">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>

      <div className="footer__bottom tra-container">
        <span>&copy; {year} {site.name}. All rights reserved.</span>
        <span className="footer__made">Built for the gaming generation.</span>
      </div>
    </footer>
  );
};

export default Footer;
